import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthService } from '../../Services/auth.service';
import { SharedService, ActionButtons } from '../../Services/shared.service';
import { Routes, Router } from '@angular/router';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss']
})

export class DashboardComponent implements OnInit, OnDestroy {

    private windowResize: Subscription;
    private PageTitle: Subscription;
    private PageLoader: Subscription;
    private PageCtrl: Subscription;

    title: string;
    sidebarState: boolean;
    loadingState: boolean;
    searchBoxState: boolean;
    pageControls: ActionButtons[];
    NavItems: Routes;

    constructor(private _auth: AuthService, private _shared: SharedService, private _router: Router) {
        // Subscribe to search box state
        this._shared.displaySearchBox.subscribe(res => this.searchBoxState = res);

        // Extracting dashboard child routes with primary flag true
        this.NavItems = this._router.config.filter(route => route.path === 'dashboard').shift()
            .children.filter(menu => menu.data.primary === true);
    }

    ngOnInit() {
        // Subscribe to Page Title
        this.PageTitle = this._shared.pageTitle$.subscribe(title => this.title = title);
        // Subscribing to window resize data.
        this.windowResize = this._shared.onResize$.subscribe(window => {
            this.sidebarState = (window.innerWidth < 769) ? false : true;
        });
        // Subscribing to pageLoader
        this.PageLoader = this._shared.loadingState$.subscribe(state => this.loadingState = state);
        // Subscribing to page controls
        this.PageCtrl = this._shared.pageControls$.subscribe(btns => this.pageControls = btns);
    }

    search(str: string) {
        // Send search string to subscribers.
        this._shared.searchString.next(str.trim());
    }

    ngOnDestroy() {
        // Unsubscribe from everything.
        if (this.windowResize) { this.windowResize.unsubscribe(); }
        if (this.PageTitle) { this.PageTitle.unsubscribe(); }
        if (this.PageLoader) { this.PageLoader.unsubscribe(); }
        if (this.PageCtrl) { this.PageCtrl.unsubscribe(); }
    }
}